<template>
    <div class="energy-data-query-manage-box">


        <div class="energy-data-query-bottom">
            <div class="query-bottom-title">
                <div style="width: 20%">报警次数</div>
                <div style="width: calc(70% - 1.5rem);margin-left:1.5rem;">当前报警趋势图</div>
            </div>
            <div style="display: flex;flex-direction: row;">
                <div id="myChart" style="width: 20%;height:calc(35vh - 2.3125rem);background-color: white;"></div>
                <div id="myChart2"
                     style="width: calc(80% - 1.5rem);margin-left:1.5rem;height:calc(35vh - 2.3125rem);background-color: white;"></div>
            </div>
        </div>


        <div class="energy-data-query-top">
            <!-- <div style="height: 30px;">-->
            <div style="height: 2rem">
                <el-col style="font-size: 0.9375rem;font-weight: 600;">
                    报警记录

                    <el-date-picker
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            style="width: 16vw;float: right;"
                            v-model="dateInterval"
                            @change="changeTime"
                            :picker-options="dateRange"
                            align="left"
                            :disabled="disabled"

                    >
                    </el-date-picker>
                    <el-radio-group v-model="timePeriod" size="mini"
                                    @change="changeType"
                                    style="float: right;margin-right: 1rem;"
                                    :disabled="disabled">
                        <el-radio-button label="day">日</el-radio-button>
                        <el-radio-button label="week">周</el-radio-button>
                        <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>


                    <!--<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>-->

                </el-col>
            </div>


            <div class="content-table">
                <flex>

                    <el-table
                            stripe
                            :default-sort="{prop: 'warningTime', order: 'descending'}"
                            @filter-change="handleFilterChange"
                            :data="tableData"
                            size="mini"
                            height="calc(65vh - 15rem)"
                            width="100%"
                            @sort-change="sortChange"
                            v-loading="tableLoading"

                    >
                        <!-- height="calc(70vh - 205px)"-->
                        <!-- <el-table-column
                                 label="序号">
                             <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                         </el-table-column>-->
                        <el-table-column
                                label="序号"
                                width="50%">
                            <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="warningTime"
                                align="center"
                                sortable="custom"
                                label="报警时间"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                prop="customerUserName"
                                align="center"
                                label="用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <!--show-overflow-tooltip-->
                        <el-table-column
                                prop="customerUserCode"
                                label="用户编号"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meterName"
                                label="设备名称"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meterCode"
                                label="设备编号"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meterNum"
                                label="表号"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="warningTypeId"
                                label="报警类型"
                                align="center"
                                column-key="channel"
                                :filters="channelFilter"
                                :formatter="warningTypeFormat"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="warningStatus"
                                label="报警状态"
                                align="center"
                                column-key="type"
                                :filters="typeFilter"
                                :formatter="tableStatusFormat">
                        </el-table-column>


                        <el-table-column
                                prop="operator"
                                label="处理人"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="operatingTime"
                                label="处理时间"
                                align="center"
                                :formatter="tableTimeFormat">
                        </el-table-column>


                    </el-table>

                </flex>
            </div>
            <!--<div style="height: 30px;width: 100%">-->
            <div style="height: 2rem;width: 100%;display: flex;background-color: white">

                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageTotal" style="width:98%"
                        :disabled="disabled" align="center">
                </el-pagination>
                <el-button @click="excel" size="small" :disabled="disabled" style="margin-right: 0.5rem">数据导出
                </el-button>

            </div>
        </div>
    </div>
    <!--<div style="height: calc(100vh - 140px);background-color: red;width: 100vw"></div>-->
</template>

<script>
  import echarts from 'echarts'
  import {option} from '@/utils/echartsUtile'
  import {
    selectWarningRecord,
    selectWarningRecordType,
    selectWarningRecordTypeCount,
    myCheck
  } from '@/api/WarningRecord'
  import {exportExcel, fromatExcelTable} from '@/utils/excelUtil'
  import {getStartAndEnd, formatDate, format, getCurrDayLast} from '@/utils/time'
  import {mapGetters} from 'vuex'
  import Flex from "../../components/Flex"
  import {comdify} from '@/utils/numberUtil'

  export default {
    name: 'alarmRecord',
    components: {
      'flex': Flex
    },
    computed: {
      ...mapGetters([
        'screenWidth'
      ])
    },
    mounted() {
      this.myChart = echarts.init(document.getElementById('myChart'), 'light')
      return new Promise((resolve, reject) => {
        this.myChart.on('legendselectchanged', (obj) => {
          let selected = obj.selected
          let count = 0
          for (let i in this.typeData) {
            if (selected[this.typeData[i].name])
              count += parseInt(this.typeData[i].count)
          }
          count = this.formatCount(count)
          this.option1.graphic[0].style.text = count
          this.option1.legend.selected = selected
          this.option1.legend.scrollDataIndex = this.scrollDataIndex
          /* let option = this.getOption();
           /!*let name = obj.name
           let flag = obj.selected[obj.name]
           if(flag)
           {
             console.log(_this.option1.graphic)
             _this.option1.graphic[0].style = []
             _this.option1.graphic[0].style.push('1')
             console.log(_this.option1.graphic)
           }
           this.*/
          this.myChart.setOption(this.option1, true)
          /*   this.myChart.resize()*/
          /*     let select_value = Object.values(obj.selected);
          let select_key = Object.keys(obj.selected);
               let n = 0;
               select_value.map(res => {
                 if(!res){
                   n++;
                 }
               });
               console.log('n',n)
               if( n === select_value.length){
                 option.legend[0].selected[obj.name] = true;
               }
          /!*  *!/*/

        });
        this.myChart.on('legendScroll', (obj) => {
          console.log(obj)
          this.scrollDataIndex = obj.scrollDataIndex
        })
        resolve(null)
      }).then(() => {
        this.myChart2 = echarts.init(document.getElementById('myChart2'), 'light')
        this.pageSize = 10
        // this.timePeriodChange(this.timePeriod)

        this.selectWarningRecord()
        this.selectWarningInfo()
        this.drawEcharts(this.timePeriod)
      })
    },
    methods: {
      sortChange(row) {
        console.log(row)
        this.orderBy = row.order
        this.selectWarningRecord()
      }, excel() {
        if (this.tableData !== null && this.tableData.length !== 0) {
          this.$notify({
            title: '提示',
            message: '正在准备导出,请稍后...',
            position: 'bottom-right',
            showClose: false,
            duration: 800
          })
          this.excelData = this.formatTitle(this.myData)
          const result = exportExcel(this.excelData, '报警记录', '数据')
          if (result == 0) {
            this.$message({
              type: 'error',
              message: '无待导出数据'
            })
          } else if (result == 1) {
            this.$message({
              type: 'error',
              message: '导出失败'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '无待导出数据'
          })
        }
        /* var wb = XLSX.utils.json_to_sheet(this.excelData)
        console.log(wb)
        wb = XLSX.utils.book_new()
        console.log(wb)
        const ws = XLSX.utils.json_to_sheet(this.excelData)
        wb.SheetNames.push('1')
        wb.Sheets['1'] = ws
        var wopts = { bookType: 'xlsx', bookSST: true, type: 'array' }
        var wbout = XLSX.write(wb, wopts)
        console.log(wbout)
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }),'测试.xlsx');*/
      }, formatTitle(data) {
        let array = [];

        for (let i in data) {
          let map = {}
          map["报警时间"] = this.excelTableTimeFormat(data[i].warningTime)

          map["用户名称"] = fromatExcelTable(data[i].customerUserName)

          map["用户编号"] = fromatExcelTable(data[i].customerUserCode)

          map["设备名称"] = fromatExcelTable(data[i].meterName)

          map["设备编号"] = fromatExcelTable(data[i].meterCode)

          map["表号"] = fromatExcelTable(data[i].meterNum)

          map["报警类型"] = this.excelWarningTypeFormat(data[i].warningTypeId)

          map["报警状态"] = this.excelTableStatusFormat(data[i].warningStatus)

          map["处理人"] = fromatExcelTable(data[i].operator)

          map["处理时间"] = this.excelTableTimeFormat(data[i].operatingTime)

          array.push(map)
        }

        return array
      },
      drawEcharts(type) {
        let dateType = null
        if (type) {
          dateType = type
        }
        /*window.onresize = () => {
          this.myChart.resize()
          this.myChart2.resize()
        }*/
        this.option2 = option()
        this.option2.toolbox = {}
        this.option2.grid.top = '10%'
        this.option2.grid.left = '4%'
        this.option2.grid.bottom = '15%'
        this.option2.grid.right = '2%'

        const customerId = this.$store.getters.customerId
        const startTime = this.startTime.getTime()
        const endTime = getCurrDayLast(this.endTime)
        const condition = {customerId, startTime, endTime, dateType}
        selectWarningRecordTypeCount(condition).then(response => { /* 报警类型统计*/
          debugger
          if (response.code === 200) {
            this.option1.legend.data = []
            this.option1.series[0].data = []
            this.option1.graphic[0].style.text = []
            this.option1.graphic[1].style.text = []

            const type = response.infoJson.type
            const time = response.infoJson.time
            this.typeData = type
            let count = 0
            type.forEach(tem => {
              this.option1.legend.data.push(tem.name)
              this.option1.series[0].data.push({value: tem.count, name: tem.name})
              count += tem.count
            })
            /*for (const i in type) {
              this.option1.legend.data.push(type[i].name)
              this.option1.series[0].data.push({value: type[i].count, name: type[i].name})
              count += type[i].count
            }*/
            /*count = 1312412*/
            count = this.formatCount(count)
            debugger
            this.option1.graphic[0].style.text += (count + '\n')
            /*if (count < 1000) {
              this.option1.graphic[0].style.text += (count + '\n')
            } else if (count >= 1000 && count < 10000) {
              const c = count + ''
              const thousand = c.substring(0, 1)
              const hundred = c.substring(1, 2)
              this.option1.graphic[0].style.text += (thousand + '.' + hundred + 'K' + '\n')
            } else if (count >= 10000 && count < 1000000) {
              if (count % 10000 !== 0) {
                count = Math.floor((count / 10000) * 100) / 100 + ''
                const b = count.split('.')
                this.option1.graphic[0].style.text += (b[0] + '.' + b[1] + 'w' + '\n')
              } else {
                count = count / 10000 + ''
                const thousand = count.substring(0, 1)
                this.option1.graphic[0].style.text += (thousand + 'w' + '\n')
              }
            } else if (count >= 1000000) {
              count = Math.floor((count / 1000000) * 100) / 100 + ''
              const b = count.split('.')
              this.option1.graphic[0].style.text += (b[0] + '.' + b[1] + 'm' + '\n')
            }
            */
            this.option1.graphic[1].style.text += ('\n次报警')

            this.option2.xAxis[0].axisLabel.rotate = 0
            /*
                        this.option2.yAxis[0].name = '报警次数'*/
            this.option2.tooltip = {
              /* 提示框*/
              trigger: 'axis'
            }
            this.option2.xAxis[0].data = []
            this.option2.series[0] = {
              name: '报警次数',
              type: 'bar',
              yAxisIndex: 0,
              data: [],
              smooth: true
            }
            if (this.timePeriod === 'day' || dateType === 'day') {
              let arr = []
              Object.keys(time).forEach((key) => {
                if (time[key] !== null && time[key] !== undefined)
                  arr.push({time: key, value: parseInt(time[key].count)})
                else
                  arr.push({time: key, value: 0})
              })
              let len = arr.length
              for (let i = 0; i < len; i++) {
                for (let j = 0; j < len - 1 - i; j++) {
                  if (arr[j].time > arr[j + 1].time) {//相邻元素两两对比
                    let temp = arr[j + 1];        //元素交换
                    arr[j + 1] = arr[j];
                    arr[j] = temp;
                  }
                }
              }
              arr.forEach((value, index) => {
                this.option2.xAxis[0].data.push(value.time)
                this.option2.series[0].data.push(parseInt(value.value))
              })
            }
            else
              Object.keys(time).forEach((key) => {
                this.option2.xAxis[0].data.push(key)
                if (time[key]) this.option2.series[0].data.push(parseInt(time[key]['count']))
                else this.option2.series[0].data.push(0)
              })

            /* this.option1.graphic[0].style.text.join('\n')*/
          } else {
            this.$message({
              type: 'error',
              message: '报警类型统计错误'
            })
          }

          this.myChart2.resize()
          this.myChart2.setOption(this.option2, true)
          this.myChart.resize()
          this.myChart.setOption(this.option1, true)
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '报警类型统计错误'
          })
        })
      },
      formatCount(count) {
        if (count >= 1000 && count < 10000) {
          this.option1.graphic[0].style.font = 'bolder 1.4rem "Microsoft YaHei",sans-serif'
          // count = (count / 1000).toFixed(2) + "K";
        } else if (count >= 10000 && count < 1000000) {
          this.option1.graphic[0].style.font = 'bolder 1.2rem "Microsoft YaHei",sans-serif'
          // count = (count / 10000).toFixed(2) + "w";
        } else if (count >= 1000000 && count < 1000000000) {
          // count = (count / 1000000).toFixed(2) + "M";
          this.option1.graphic[0].style.font = 'bolder 1rem "Microsoft YaHei",sans-serif'
        } else if (count >= 1000000000) {
          // count = (count / 1000000000).toFixed(2) + "B";
          this.option1.graphic[0].style.font = 'bolder 0.8rem "Microsoft YaHei",sans-serif'
        } else if (count <= -1000 && count > -10000) {
          // count = (count / 1000).toFixed(2) + "K";
          this.option1.graphic[0].style.font = 'bolder 1.4rem "Microsoft YaHei",sans-serif'
        } else if (count <= -10000 && count > -1000000) {
          this.option1.graphic[0].style.font = 'bolder 1.2rem "Microsoft YaHei",sans-serif'
          // count = (count / 10000).toFixed(2) + "w";
        } else if (count <= -1000000 && count > -1000000000) {
          this.option1.graphic[0].style.font = 'bolder 1rem "Microsoft YaHei",sans-serif'
          // count = (count / 1000000).toFixed(2) + "M";
        } else if (count <= -1000000000) {
          // count = c(count / 1000000000).toFixed(2) + "B";
          this.option1.graphic[0].style.font = 'bolder 0.8rem "Microsoft YaHei",sans-serif'
        }
        return comdify(count)
      },
      selectWarningInfo() {
        const customerId = this.$store.getters.customerId

        selectWarningRecordType(customerId).then(response => { /* 查询报警类型*/
          if (response.code === 200) {
            this.channelFilter = []
            const result = response.infoJson
            for (const i in result) {
              this.channelFilter.push({'text': result[i].name, 'value': result[i].id})
            }
            this.mapping = result
          } else {
            this.$message({
              type: 'error',
              message: '查询报警类型错误'
            })
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '查询报警类型错误'
          })
        })
      },
      selectWarningRecord() {
        this.tableLoading = true
        if (this.pageTotal) this.pageTotal = 0
        const customerId = this.$store.getters.customerId
        const startTime = this.startTime.getTime()
        const endTime = getCurrDayLast(this.endTime)
        const warningStatus = this.warningStatus
        const warningTypeId = this.warningTypeId
        const orderBy = this.orderBy
        const condition = {customerId, startTime, endTime, warningTypeId, warningStatus, orderBy}
        selectWarningRecord(condition).then(response => { /* 报警记录查询*/
          if (response.code === 200) {
            this.myData = response.infoJson
            this.currentPage = 1
            this.tableData = this.searchByPage(this.myData)

            /* this.page.total = data.total
             this.page.current = data.current
             this.page.size = data.size
             this.page.pages = data.pages*/
          } else {
            this.$message({
              type: 'error',
              message: '报警记录查询错误'
            })
          }
          this.tableLoading = false
        }).catch(error => {
          console.log(error)
          this.tableLoading = false
          this.$message({
            type: 'error',
            message: '报警记录查询错误'
          })
        })
      },
      handleSizeChange: function (size) {
        this.pageSize = size
        this.tableData = this.searchByPage(this.myData)
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        this.tableData = this.searchByPage(this.myData)
      },
      searchByPage(data) {
        if (data === null || data === undefined || data.length === 0) return []
        /* 数据总个数dataTotal, pageTotal总页数, 每页个数pagesize, 当前页数currentPage*/
        const dataTotal = data.length
        this.pageTotal = dataTotal
        /* dataTotal / pageSize + ((dataTotal % pageSize) > 0 ? 1 : 0);*/
        const start = ((this.currentPage - 1) * this.pageSize)
        const end = this.currentPage * this.pageSize
        return data.slice(start, end)

      }, labelHead(h, {column, index, value}) {
        const l = column.length
        const f = 16 // 每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
        column.minWidth = f * l // 字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
        // 然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
        return h('div', {class: 'table-head', style: {width: '100%'}}, [column.label])
      }, tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      }, tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      tableStatusFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue === 1) return '报警结束'
          else if (cellValue === 0) return '报警中'
          //else if (cellValue === 2) return '恢复中'
        }
        return '--'
      }, excelTableStatusFormat(cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue === 1) return '报警结束'
          else if (cellValue === 0) return '报警中'
          //else if (cellValue === 2) return '恢复中'
        }
        return '--'
      }, warningTypeFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          for (const i in this.mapping) {
            if (this.mapping[i].id === cellValue) {
              if (this.mapping[i].name === '充值失败')
                return <font style="color: red">充值失败</font>
              else return this.mapping[i].name
            }
          }
        }
        return '--'
      }, excelWarningTypeFormat(cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          for (const i in this.mapping) {
            if (this.mapping[i].id === cellValue) return this.mapping[i].name
          }
        }
        return '--'
      }, excelTableTimeFormat(cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      changeTime(time) {
        this.timePeriod = ''
        this.startTime = time[0]
        this.endTime = time[1]
        /* - 8.64e6*/
        /*alert(8.64e6)*/
        if (this.endTime - this.startTime > 60 * 60 * 24 * 31 * 1000) {
          this.$message({
            message: '选择时间段超过31天,请重新选择!',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        else if (this.endTime - this.startTime === 0) {

          this.endTime.setHours('23')
          this.endTime.setMinutes('59')
          this.endTime.setSeconds('59')

          this.selectWarningRecord()
          this.drawEcharts('day')
          return
        }

        this.selectWarningRecord()
        this.drawEcharts()
      }, handleFilterChange(filters) { // 表格筛选
        // 报警类型筛选
        if (filters.channel !== undefined) {
          this.warningTypeId = filters.channel
        }
        // 报警状态筛选
        if (filters.type !== undefined) {
          this.warningStatus = filters.type
        }
        // 查询表格数据
        this.selectWarningRecord()
      }, timePeriodChange(val) { // 根据时间段改变设置时间框的值
        this.dateInterval = []
        const timeJson = getStartAndEnd('now', val)
        const timeArr = [timeJson.start, timeJson.end]
        this.startTime = timeArr[0]
        this.endTime = timeArr[1]
        this.selectWarningRecord()
        this.drawEcharts(val)
      }, changeType(val) { // 监听时间区间变化，并赋值时间选择框
        this.timePeriodChange(val)
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      screenWidth() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            this.myChart.resize()
            this.myChart2.resize()
            this.timer = false
          }, 10)
        }
      },
      /*, dateInterval(val) { // 监听时间框变化，查询数据
        if (this.dateInterval !== null) {
          this.selectWarningRecord()
          this.drawEcharts();
        }
      }*/
    },
    data() {
      return {
        tableLoading: false,
        typeData: [],
        startTime: getStartAndEnd('now', 'month').start,
        endTime: getStartAndEnd('now', 'month').end,
        warningTypeId: '',
        warningStatus: '',
        dateInterval: [],
        timePeriod: 'month',
        disabled: false,
        page: {}, /* 分页对象*/
        orderBy: 'descending',
        condition: {}, /* 查询条件*/
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
        tableData: [], /* 表格数据*/
        myData: [], /*分页数据*/
        excelData: [], /*excel数据*/
        option2: {},
        mapping: [],
        colorList: ['#F1511B', '#F8AD34', '#E88678', '#4774BF', '#009BAC'],
        channelFilter: [],
        typeFilter: [{'text': '报警中', 'value': '0'}, {'text': '报警结束', 'value': '1'}],
        dateRange: {
          disabledDate(time) {
            return time.getTime() > Date.now() + 2592000000 - 8.64e6
          }
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'week')
              const start = startAndEnd.start
              const end = startAndEnd.end

              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'month')
              const start = startAndEnd.start
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 3, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* console.log()
              let start = formatDate(new Date(new Date()- (3600 * 1000 * 24 * 121))) + ' 00:00:00'
              let end = formatDate(new Date()) + ' 23:59:59'
              picker.$emit('pick', [start, end])*/
            }
          }, {
            text: '最近半年',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 6, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])*/
            }
          }]
        },
        scrollDataIndex: 0,
        option1: {
          /*color: (index)=>{
            return this.colorList[index]
          },*/
          tooltip: {
            position: (point, params, dom, rect, size) => {/*提示框位置计算*/
              //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
              let x = point[0];//
              let y = point[1];
              let viewWidth = size.viewSize[0];
              let viewHeight = size.viewSize[1];
              let boxWidth = size.contentSize[0];
              let boxHeight = size.contentSize[1];
              let posX = 0;//x坐标位置
              let posY = 0;//y坐标位置

              if (x < boxWidth) {//左边放不开
                posX = 5;
              } else {//左边放的下
                posX = x - boxWidth;
              }

              if (y < boxHeight) {//上边放不开
                posY = 5;
              } else {//上边放得下
                posY = y - boxHeight;
              }

              return [posX, posY];

            },

            trigger: 'item',
            // formatter: '{a} <br/>{b}: {c} 次  ({d}%)'
            formatter: (params) => {
              return params.seriesName + '<br/>' + params.marker + params.name + ': ' + comdify(params.value) + '次' + '(' + params.percent + '%)'
            }
            // ,
            // formatter: (value)=>{
            //   console.log(value)
            //   const data = value.value
            //   const seriesName = value.seriesName
            //   const name = value.name
            //   const percent = value.percent
            //   let val;
            //   val = seriesName + "<br/>";
            //   val += name+" :";
            //   val += data
            //   val += '(' + percent + '%)'
            //   return val;
            // }
          },
          legend: {
            selected: {},
            orient: 'horizontal',
            align: "auto",
            type: 'scroll',//图例标记和文本的对齐,left,right
            /* padding:0,                                   //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
             itemGap:10,                                  //图例每项之间的间隔
             itemWidth:10,                               //图例标记的图形宽度
             itemHeight:10,*/
            x: 'center',
            y: '75%',
            data: []
          }, grid: {
            top: '0%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: false
          }, graphic: [{
            $action: 'replace',
            z: 100,
            silent: false,
            bouding: 'raw',
            type: 'text',
            left: 'center',
            top: '26%',
            draggable: false,
            style: {
              /* x: 3,
               y: 10,*/
              fill: '#222222',
              text: '',
              /* bouding: 'all',*/
              font: 'bolder 1.8rem "Microsoft YaHei",sans-serif',
              textAlign: 'center'
            }

          }, {
            $action: 'replace',
            type: 'text',
            z: 100,
            left: 'center',
            top: '34%',
            bouding: 'all',
            style: {
              /*center: ['50%', '35%'],*/
              fill: '#777',
              text: '',
              font: '1rem "Microsoft YaHei" , sans-serif',
              textAlign: 'center'
            }

          }

          ],
          series: [
            {
              name: '报警次数',
              type: 'pie',
              color: [],
              radius: ['40%', '60%'],
              center: ['50%', '35%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                  /* position: 'inside',
                  offset:[30, 60],*/
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: []/*,
              itemStyle: {
                normal: {
                  //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                  color: ['#4774BF', '#F8AD34', '#F1511B', '#E88678', '#009BAC'],
                  }

              }*/
            }
          ]
        }
      }
    }

  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .energy-data-query-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        font-size: 1rem;
        .energy-data-query-top {
            margin-top: 1rem;
            width: 100%;
            height: calc(65vh - 9.75rem);
            display: flex;
            flex-direction: column;
            font-size: 1rem;

            .content-table {
                padding-top: 0.5rem;
                height: calc(65vh - 15rem);
                width: 100%;
            }

        }

        .energy-data-query-bottom {
            width: 100%;
            display: flex;
            height: calc(35vh - 0.3125rem);
            flex-direction: column;
            padding-bottom: 0.3125rem;
        }
        .query-bottom-title {
            height: 2rem;
            display: flex;
            flex-direction: row;
            font-size: 15px;
            font-weight: 600;
        }
    }
</style>
